import * as go from 'gojs';
import { getImageLinearMotionScreen } from 'unitData/LinearMotionScreen/getImageLinearMotionScreen';
import {
  getDeckPortPanel,
  getImageBinding,
  getIOPort,
  makeNode,
} from '../../utils';
import type { ScreenNodeData } from 'gojs/types';

const alignScreenPort = (
  mirrored: boolean,
  portIndex: number,
  decks?: number,
) => {
  const x = mirrored ? 0 : 1;

  if (decks === 1) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 4 / 6);
      case 1:
        return new go.Spot(0.5, 1);
    }
  } else if (decks === 2) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 3 / 6);
      case 1:
        return new go.Spot(x, 4 / 6);
      case 2:
        return new go.Spot(0.5, 1);
    }
  } else if (decks === 3) {
    switch (portIndex) {
      case 0:
        return new go.Spot(x, 3 / 6);
      case 1:
        return new go.Spot(x, 4 / 6);
      case 2:
        return new go.Spot(x, 5 / 6);
      case 3:
        return new go.Spot(0.5, 1);
    }
  }
};

const LinearMotionScreenTemplate = makeNode(
  getImageBinding('', (node: ScreenNodeData) =>
    getImageLinearMotionScreen(node.nbrOfDecks, node.unitInfo.screenFamily),
  ),
  [
    getIOPort(go.Spot.Top, 'input'),
    getDeckPortPanel(0, alignScreenPort),
    getDeckPortPanel(1, alignScreenPort),
    getDeckPortPanel(2, alignScreenPort, (node) => node.nbrOfDecks >= 2),
    getDeckPortPanel(3, alignScreenPort, (node) => node.nbrOfDecks >= 3),
  ],
);

export default LinearMotionScreenTemplate;
